
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../common/util.bs.js";
import * as React from "react";
import * as Button from "../components/library/Button.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as StaticImage from "../components/StaticImage.bs.js";
import * as Router from "next/router";
import * as Localization from "../config/Localization.bs.js";
import * as HelpersTs from "../api/helpers.ts";
import * as JsxRuntime from "react/jsx-runtime";
import * as ResponsiveClipboard from "../components/library/ResponsiveClipboard.bs.js";

function getSessionIdToken(prim) {
  return HelpersTs.getSessionIdToken(prim);
}

var rootContainer = "text-center my-20 w-10/12 md:w-1/2 mx-auto self-center animate__animated animate__fadeIn animate__slow";

var heading = "text-2xl md:text-4xl font-bold";

var img = "mx-auto my-4";

var imgAnimated = img + " animate__animated animate__jackInTheBox animate__slow";

var text = "text-lg mt-8 mx-auto text-gray-600";

function Pending(props) {
  React.useEffect((function () {
          window.scrollTo(0, 0);
          HelpersTs.getSessionIdToken({
                updateConfig: true,
                resetToken: true
              });
        }), []);
  var router = Router.useRouter();
  var orderNumberOpt = Js_dict.get(router.query, "order");
  var fraudOpt = Js_dict.get(router.query, "paymentassessment");
  var riskOpt = Js_dict.get(router.query, "riskassessment");
  var nowrap = function (text) {
    return Util.ReactStuff.s(text.replace(/ /g, "\u00a0"));
  };
  return JsxRuntime.jsx("div", {
              children: Belt_Option.isSome(riskOpt) ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx(StaticImage.make, {
                              src: "/images/error_icon.svg",
                              alt: "Order failed",
                              width: 60,
                              height: 60,
                              className: img
                            }),
                        JsxRuntime.jsx("h1", {
                              children: Util.ReactStuff.s("We couldn't complete your order"),
                              className: heading
                            }),
                        JsxRuntime.jsxs("p", {
                              children: [
                                Util.ReactStuff.s("If you need any help, please "),
                                JsxRuntime.jsx("a", {
                                      children: Util.ReactStuff.s("contact us"),
                                      className: "text-blue-500 underline hover:no-underline",
                                      href: Belt_Option.getWithDefault(Localization.getLocalizedString("riskLink"), "/contact/"),
                                      target: "_blank"
                                    }),
                                Util.ReactStuff.s(".")
                              ],
                              className: text
                            })
                      ]
                    }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsx("h1", {
                              children: Util.ReactStuff.s("Oh no!"),
                              className: heading
                            }),
                        JsxRuntime.jsx(StaticImage.make, {
                              src: "/images/failed.png",
                              alt: "Order failed",
                              width: 192,
                              height: 198,
                              className: imgAnimated
                            }),
                        Belt_Option.isSome(fraudOpt) ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("p", {
                                      children: [
                                        Util.ReactStuff.s("We were not able to process your order as we could not validate your billing details. Please contact our Customer Care team at "),
                                        Belt_Option.mapWithDefault(Localization.getLocalizedString("supportEmail"), null, Util.ReactStuff.s),
                                        Util.ReactStuff.s(" or "),
                                        Belt_Option.mapWithDefault(Localization.getLocalizedString("phoneNumberWithoutCountryCode"), null, nowrap),
                                        Util.ReactStuff.s(" (or +61 2 9093 2777 if you're overseas), we're here to help 24/7.")
                                      ],
                                      className: text
                                    })
                              }) : JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("Something went wrong and we could not complete your request."),
                                        className: text
                                      }),
                                  JsxRuntime.jsx("p", {
                                        children: Util.ReactStuff.s("Our team has been notified and will resolve the issue as soon as we can."),
                                        className: text
                                      }),
                                  JsxRuntime.jsxs("p", {
                                        children: [
                                          Util.ReactStuff.s("Should you need any urgent assistance or more information, please contact us at "),
                                          Belt_Option.mapWithDefault(Localization.getLocalizedString("supportEmail"), null, Util.ReactStuff.s),
                                          Util.ReactStuff.s(" or "),
                                          Belt_Option.mapWithDefault(Localization.getLocalizedString("phoneNumber"), null, nowrap)
                                        ],
                                        className: text
                                      })
                                ]
                              }),
                        Belt_Option.mapWithDefault(orderNumberOpt, null, (function (orderNumber) {
                                return JsxRuntime.jsx(ResponsiveClipboard.make, {
                                            orderNumber: orderNumber
                                          });
                              })),
                        JsxRuntime.jsx("button", {
                              children: Util.ReactStuff.s("Go back"),
                              className: Cn.make([
                                    "my-6 w-40 py-4 mx-auto",
                                    Button.primaryStyle
                                  ]),
                              title: "Go back",
                              onClick: (function (e) {
                                  e.preventDefault();
                                  router.back();
                                })
                            })
                      ]
                    }),
              className: rootContainer
            });
}

var Link;

var submitBtnStyle = "mx-auto mt-6 w-56 h-12";

var make = Pending;

var $$default = Pending;

export {
  Link ,
  getSessionIdToken ,
  rootContainer ,
  heading ,
  img ,
  imgAnimated ,
  text ,
  submitBtnStyle ,
  make ,
  $$default ,
  $$default as default,
}
/* Util Not a pure module */
